import React from 'react';
import PropTypes from 'prop-types';

class IconQR extends React.PureComponent {
    static propTypes = {
        id: PropTypes.string,
        qrCode: PropTypes.string
    };

    state = {
        showImage: false
    };

    toggleDisplayImage = () => {
        this.setState({
            showImage: !this.state.showImage
        });
    }

    render() {
        const showImageClass = this.state.showImage ? 'display' : '';
        const {id} = this.props;
        const qrCode = this.props.qrCode || null;

        let qrCodeElement;
        if (qrCode) {
            const style = {
                backgroundImage: `url(${qrCode})`
            };
            qrCodeElement = (
                <button className="qr-opener" onClick={this.toggleDisplayImage}>
                    <i className={`text-color-nonactive accent-color-hover eg-footer-icon-${id}`}>&nbsp;</i>
                    <div className={`image-container qrcode-bg ${showImageClass}`} style={style} />
                </button>
            );
        }

        return (
            <div>
                { qrCodeElement || (
                    <i className={`text-color-nonactive accent-color-hover eg-footer-icon-${id}`}>&nbsp;</i>
                )}
            </div>
        );
    }
}

export default IconQR;
